import React, { Component } from 'react';
import { Icon as AntIcon } from 'antd';
import './InfoBanner.scss';

export default class InfoBanner extends Component {
  render() {
    return (
      <div className="info-banner">
        <div className="info-banner-content">
          <div className="info-banner-header">
            <AntIcon 
              type="info-circle" 
              className="info-banner-icon"
            />
            <h3 className="info-banner-title">We're moving to Naluri Care</h3>
          </div>
          <p className="info-banner-description">
            Coach Platform (CP1.0) will be retired in January 2026. Switch to{' '}
            <a 
              href="https://care.naluri.life" 
              target="_blank" 
              rel="noopener noreferrer"
              className="info-banner-link"
            >
              https://care.naluri.life
            </a>
            {' '}today to continue supporting your members with a faster, more seamless coaching experience.
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/InfoBanner.js